/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_CustompropertyInputs */

const en_entity_customproperty = /** @type {(inputs: Entity_CustompropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property`)
};

const de_entity_customproperty = /** @type {(inputs: Entity_CustompropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property`)
};

/**
* | output |
* | --- |
* | "Custom Property" |
*
* @param {Entity_CustompropertyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_customproperty = /** @type {((inputs?: Entity_CustompropertyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_CustompropertyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_customproperty(inputs)
	return de_entity_customproperty(inputs)
});